import { Link } from "react-router-dom";

const FAQ = [
  {
    q: "How does ConcertDeals calculate the total trip cost?",
    a: "For every upcoming tour date we add three things: the concert ticket price, a round-trip flight from your home airport, and a 2-night hotel near the venue. We then rank every city by that all-in total.",
  },
  {
    q: "What are the three packages?",
    a: "Cheapest combines the lowest ticket, flight, and hotel we can find. Best Value pairs a mid-tier ticket with the cheapest flight and a comfortable 3-star hotel. Premium uses the best seats, a nonstop flight, and a 4-star hotel.",
  },
  {
    q: "Do you search nearby airports?",
    a: "Yes. If your home airport belongs to a metro area (for example New York's JFK, LGA, and EWR) we search all of them and keep the cheapest combination.",
  },
  {
    q: "Are these prices guaranteed?",
    a: "Prices are live estimates from our booking partners and can change between search and checkout. The final price is always confirmed on the partner's site before you pay.",
  },
  {
    q: "Does ConcertDeals cost anything?",
    a: "No. The search is free. We earn a commission from booking partners when you book through our links, at no extra cost to you.",
  },
];

export function HowItWorksPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      <h1 className="text-3xl font-bold text-slate-900">How it works</h1>
      <p className="mt-3 text-slate-600">
        ConcertDeals answers one question:{" "}
        <span className="font-medium text-slate-900">
          what is the cheapest city to see this artist?
        </span>{" "}
        We compare the complete trip cost across every tour stop so you don&apos;t
        have to.
      </p>

      <ol className="mt-8 space-y-6">
        <li className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="font-semibold text-slate-900">1. Search an artist</h2>
          <p className="mt-1 text-sm text-slate-500">
            Enter any artist and your home airport. We pull every upcoming US
            tour date from our concert data partner.
          </p>
        </li>
        <li className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="font-semibold text-slate-900">
            2. We price the whole trip
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            For each show we fetch live flight and hotel prices and combine them
            with the ticket cost into three ready-to-book packages.
          </p>
        </li>
        <li className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="font-semibold text-slate-900">
            3. Compare and book
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Every city is ranked by total all-in cost. Pick the package that
            fits and book through our partners.
          </p>
        </li>
      </ol>

      <h2 className="mt-12 text-2xl font-bold text-slate-900">
        Frequently asked questions
      </h2>
      <dl className="mt-6 divide-y divide-slate-200 border-y border-slate-200">
        {FAQ.map((item) => (
          <div key={item.q} className="py-5">
            <dt className="font-medium text-slate-900">{item.q}</dt>
            <dd className="mt-2 text-sm text-slate-500">{item.a}</dd>
          </div>
        ))}
      </dl>

      <section
        id="affiliate"
        className="mt-12 scroll-mt-20 rounded-xl bg-slate-50 p-6"
      >
        <h2 className="text-lg font-semibold text-slate-900">
          Affiliate disclosure
        </h2>
        <p className="mt-2 text-sm text-slate-500">
          ConcertDeals participates in affiliate programs with ticketing,
          flight, and hotel partners. When you book through links on this site
          we may earn a commission. This never changes the price you pay and
          does not influence how we rank results — cities are always ordered by
          lowest total trip cost.
        </p>
      </section>

      <div className="mt-10 text-center">
        <Link
          to="/search"
          className="inline-block rounded-lg bg-brand-600 px-6 py-3 text-base font-semibold text-white hover:bg-brand-700"
        >
          Try a search
        </Link>
      </div>
    </div>
  );
}
